export default "__VITE_ASSET__Dm3DWk$1__"